import React, { useEffect, useState } from 'react';

import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';

import ReactMarkdown from 'react-markdown';
import { AppContext } from 'src/contexts/appContext';

import './github-markdown.css';

export const ReleaseNotes = () => {
    const [notes, setNotes] = useState('');
    const { isSideBarClosed, setIsSideBarClosed } = React.useContext(AppContext);

    useEffect(() => {
        fetch('/releaseNotes.md')
            .then((response) => response.text())
            .then((text) => setNotes(text));
    }, []);

    // Make left side nav closed when landing on release notes screen, and reset side nav to be open when leaving
    useEffect(() => {
        if (!isSideBarClosed) setIsSideBarClosed(true);

        return () => {
            setIsSideBarClosed(false);
        };
    }, []);

    return (
        <Column width="100%">
            <Box type="fill" spacingInset="500">
                <Row alignmentHorizontal="center">
                    <Heading level={2}>{'Release Notes'}</Heading>
                </Row>
            </Box>
            <Row spacingInset="500" spacing="500">
                <ReactMarkdown className="markdown-body">{notes}</ReactMarkdown>
            </Row>
        </Column>
    );
};
